import { AdminTaskStatus } from './AdminTaskStatus';

export class FindModel {
    constructor() {
        this.statuses = [];
    }

    assignedTo?: string;
    folder?: string;
    statuses: AdminTaskStatus[];

    start?: Date;
    end?: Date;
}